'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Theme = require('./Theme.js');
var DarkTheme = require('./DarkTheme.js');
var LightTheme = require('./LightTheme.js');



exports["default"] = Theme.theme;
exports.theme = Theme.theme;
exports.darkTheme = DarkTheme.darkTheme;
exports.lightTheme = LightTheme.lightTheme;
